module.exports = __webpack_public_path__ + "svg/plus-illustration.ee727b5.svg";